import React, { Component, useEffect, useState } from 'react';
import { TextFieldComponent } from './FormElement';
import { Field, Form } from 'react-final-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyCheckAlt, faInfo } from '@fortawesome/free-solid-svg-icons';
import defaultTheme from '../theme.css';
import { Grid, Tooltip } from '@material-ui/core';
import ButtonCustom from './ButtonCustom';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { styled } from '@material-ui/styles';

const TextOnlyTooltip = withStyles({
    tooltip: {
      color: "black",
      backgroundColor: "#fff",
      fontSize: 14,
      border: '1px solid #eee',
      textAlign: 'center'
    }
  })(Tooltip);

const styles = theme => ({
    info_hover: {
        position: 'absolute',
        background: theme.palette.background.secondary,
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1),
        zIndex: 1000,
        marginTop: theme.spacing(20),
        border: '1px solid' + theme.palette.border.secondary,
        marginRight: theme.spacing(5)
    },
    icon_hover: {
        '&:hover': {
            cursor: 'pointer'
        }
    }
});

function FormSerialOTP(props){
    const {classes} = props;
    const [show, setShow] = useState(false);
    useEffect(() => {
        document.addEventListener('click', function(){
            setShow(false);
        });
    },[]);
    const onSubmit = () => {

    }
    return (
        <Grid item style={{marginLeft: 12}}>
            <Form onSubmit={onSubmit}
                render={({ handleSubmit, reset, submitting, pristine, values }) => (
                    <Grid item style={{display: 'flex', alignItems: 'center'}}>
                        <Grid item>
                            <FontAwesomeIcon icon={faMoneyCheckAlt} color={defaultTheme.palette.icon.acitve} size="2x" style={{marginRight: defaultTheme.spacing * 2}}/>
                        </Grid>
                        <Field
                            name="serial_number"
                            component={TextFieldComponent}
                            placeholder={"Serial Number"}
                            isEdit={true}
                            color='default'
                            autoFocus={true}
                        />
                        <Grid item style={{paddingLeft: 8}} className={classes.icon_hover}>
                            <TextOnlyTooltip  title="Start your TV and from the TV remote control select MENU/Device/Register device and type the 6 digit OTP No.">
                                <div>
                                    <FontAwesomeIcon icon={faInfo} color={defaultTheme.palette.icon.acitve} style={{fontSize: '1.25rem', marginRight: defaultTheme.spacing * 2}}/>
                                </div>
                            </TextOnlyTooltip>
                        </Grid>
                        <Field
                            name="input_otp"
                            component={TextFieldComponent}
                            placeholder={"Enter OTP"}
                            isEdit={true}
                            color='default'
                            autoFocus={true}
                        />
                        <Grid item container justify='center' className={classes.marginTop4x} style={{minWidth: 100, maxWidth: 100}}>
                            <ButtonCustom color='primary' onClick={handleSubmit} size='sm' style={{width: '100%'}}>{"Submit"}</ButtonCustom>
                        </Grid>
                        {/* {show && <div className={classes.info_hover}>Start your TV and from the TV remote control select MENU/Device/Register device and type the 6 digit OTP No.</div>} */}
                    </Grid>
                )}/>
        </Grid>
    );
}

export default withStyles(styles)(withTranslation()(FormSerialOTP))